let UserManual = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;

  this.getUserManualCategory = function (parentId, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/Manager/All/UserManualCategories/${parentId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };

  this.addUserManualCategory = function (category, success, error) {
    var url = ServiceBaseAddress + "/api/UserManual/Manager/Category";
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      category,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };

  this.setIsEnable = function (categoryId, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/Manager/Category/Enable/${categoryId}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.editUserManualCategory = function (category, success, error) {
    if (category) {
      var url = ServiceBaseAddress + "/api/UserManual/Manager/Category";
      TokenClient.Put(
        url,
        true,
        { "Content-Type": "application/json" },
        category,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data);
            success(jsonObj);
          }
        },
        error
      );
    }
  };

  this.removeUserManualCategory = function (categoryId, success, error) {
    var url = ServiceBaseAddress + "/api/UserManual/Manager/Category/" + categoryId;
    TokenClient.Delete(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.getUserManual = function (clientId, keyWord, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/Manager/UserManuals`;
    if (clientId) {
      url += `/${clientId}`;
    } else {
      url += "/%20";
    }
    if (keyWord) {
      url += `/${keyWord}`;
    } else {
      url += "/%20";
    }
    if (pageIndex) {
      url += `/${pageIndex}`;
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.getUserManuals = function (clientId, keyWord, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/UserManuals/${clientId}`;
    if (keyWord) {
      url += `/${keyWord}`;
    } else {
      url += "/%20";
    }
    // url += `/${pageIndex}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.addUserManual = function (category, success, error) {
    var url = ServiceBaseAddress + "/api/UserManual/Manager/UserManuals";
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      category,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.editUserManual = function (category, success, error) {
    if (category) {
      var url = ServiceBaseAddress + "/api/UserManual/Manager/UserManuals";
      TokenClient.Put(
        url,
        true,
        { "Content-Type": "application/json" },
        category,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data);
            success(jsonObj);
          }
        },
        error
      );
    }
  };
  this.setUserManualsIsEnable = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/Manager/UserManuals/Enable/${id}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };

  this.removeUserManual = function (id, success, error) {
    var url = ServiceBaseAddress + "/api/UserManual/Manager/UserManuals/" + id;
    TokenClient.Delete(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.getUserManualsDetail = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/UserManual/UserManualsDetail/${id}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
};

export { UserManual };
